import React from "react";
import "./ScrollingGallery.css";
import story1 from "./media/prime5.jpg";
import story2 from "./media/prime6.jpg";
import story3 from "./media/prime7.jpg";
import story4 from "./media/prime8.jpg";
import story5 from "./media/prime9.jpg";
import story6 from "./media/prime17.jpg";
import story7 from "./media/prime13.jpg";
import story8 from "./media/prime11.jpg";
import story9 from "./media/operation.jpg";
import story10 from "./media/pme.jpg";
import story11 from "./media/ps6.jpg";
import story12 from "./media/ps4.JPG";
import story13 from "./media/ps9.jpg";

export default function ScrollingGallery() {
  const row1 = [story1, story2, story13, story4, story5, story9];

  const row2 = [story4, story12, story7, story9, story10, story11];

  const row3 = [story7, story8, story9, story10, story11, story12];

  return (
    <section className="scrolling-gallery-section">
      {/* hero overlay (left side headline + CTA) */}
      <div className="gallery-hero">
        <div className="hero-inner">
          {/* <div className="eyebrow">SIENNA</div> */}
          <h1 className="hero-title">
            TRANSFORMING SMILES
            WITH PRECISION<br />
            AND ARTISTRY
          
          </h1>

          {/* <a className="browse-cta" href="#gallery">
            <span className="cta-arrow">▸</span>
            <span className="cta-text">BROWSE GALLERY</span>
          </a> */}
        </div>

        {/* the left dark fade to make text readable */}
        <div className="left-fade" aria-hidden="true" />
      </div>

      {/* actual moving gallery rows */}
      <div className="scrolling-gallery">
        <div className="row scroll-left-to-right">
          <div className="inner">
            {row1.concat(row1).map((src, i) => (
              <img key={i} src={src} alt={`gallery ${i}`} draggable="false" />
            ))}
          </div>
        </div>

        <div className="row scroll-right-to-left">
          <div className="inner">
            {row2.concat(row2).map((src, i) => (
              <img key={i} src={src} alt={`gallery ${i}`} draggable="false" />
            ))}
          </div>
        </div>

        <div className="row scroll-left-to-right">
          <div className="inner">
            {row3.concat(row3).map((src, i) => (
              <img key={i} src={src} alt={`gallery ${i}`} draggable="false" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
